export default {
    namespaced: true,
    state: {
		format: window.innerWidth < 768 ? 'small' : window.innerWidth < 1030 ? 'medium' : 'big',
		scrollTop: 0,
		groupScrollTop: 0,
		activeProsp: '',
		activegroupProsp: '',
		activeConvo: '',
		activegroupConvo: '',
		messages: {},
		grpmessages: {},
		startCount:null,
		unreadCountTotal:null,
		autopilotCountTotal:null,
		scheduleCountTotal:null,
		dueTaskCountTotal:null
	},
    mutations: {
		SET(state, payload) {
			switch (payload.var) {
				case 'vw':
					state.format = payload.val < 768 ? 'small' : payload.val < 1030 ? 'medium' : 'big';
					break;
				case 'scrollTop':
					state.scrollTop = payload.val;
					break;
				case 'groupScrollTop':
					state.groupScrollTop = payload.val;
					break;
				case 'activeProsp':
					state.activeProsp = payload.val;
					break;
				case 'activegroupProsp':
					state.activegroupProsp = payload.val;
					break;
				case 'activeConvo':
					state.activeConvo = payload.val;
					break;
				case 'activegroupConvo':
					state.activegroupConvo = payload.val;
					break;
				case 'startCount':
					state.startCount = payload.val;
					break;
				case 'unreadCountTotal':
					state.unreadCountTotal = payload.val;
					break;
				case 'autopilotCountTotal':
					state.autopilotCountTotal = payload.val;
					break;
				case 'scheduleCountTotal':
					state.scheduleCountTotal = payload.val;
					break;
				case 'dueTaskCountTotal':
					state.dueTaskCountTotal = payload.val;
					break;
			}
		},
		CLEAR(state, target) {
			switch (target) {
				case 'scrollTop':
					state.scrollTop = 0;
					break;
				case 'groupScrollTop':
					state.groupScrollTop = 0;
					break;
				case 'activeProsp':
					state.activeProsp = '';
					break;
				case 'activegroupProsp':
						state.activegroupProsp = '';
						break;
						case 'activeConvo':
					state.activeConvo = '';
					break;
				case 'activegroupConvo':
					state.activegroupConvo = '';
					break;
				case 'startCount':
					state.startCount = null;
					break;
				case 'unreadCountTotal':
					state.unreadCountTotal = null;
					break;
				case 'autopilotCountTotal':
					state.autopilotCountTotal = null;
					break;
				case 'scheduleCountTotal':
					state.scheduleCountTotal = null;
					break;
				case 'dueTaskCountTotal':
					state.dueTaskCountTotal = null;
					break;
			}
		},
		CLEAR_ALL(state) {
			state.scrollTop = 0;
			state.groupScrollTop = 0;
			state.activeProsp = '';
			state.activegroupProsp = '';
			state.activeConvo = '';
			state.activegroupConvo = '';
			state.messages = {};
			state.grpmessages = {};
			state.startCount = null;
			state.unreadCountTotal = null;
			state.autopilotCountTotal = null;
			state.scheduleCountTotal = null;
			state.dueTaskCountTotal = null;
		}
	},
	actions: {
		CLEAR_ALL({ commit }) {
			commit('CLEAR_ALL');
		}
	},
}
